<template>
  <div>
    <!--------委托项目---------->
    <div v-if="entrustProject.projectId" class="card">
      <entrust-info-dialog
        v-model="orderId"
        :entrust-info="entrustProject"
        :read-only="true"
        :is-release="true"
      />
    </div>

    <!----谈判采购信息---->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="谈判采购信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="infoOptions"
            :el-attrs="{
              size: 'medium',
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:budgetAmountWy="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 万元</span>
              <money-in-cn :money="value" :multiple="10000" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-----竞争方式----->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="竞争方式" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="typeOptions"
            :el-attrs="{
              size: 'medium',
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:otherRequireList>
              <other-material-requirements
                class="detail-content-width"
                :table="orderInfo.otherRequireList || []"
                mode="detail"
              />
            </template>
            <!-- 线上评审文件 -->
            <template v-slot:reviewWayList>
              <el-button
                type="text"
                style="padding: 2px"
                @click="jumpReviewInfo()"
              >
                查看详情
              </el-button>
            </template>

            <!-- 内部文件 -->
            <template v-slot:internalAttachments>
              <upload
                v-if="orderInfo.internalAttachments"
                :file-id-before="orderInfo.internalAttachments"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-----谈判文件----->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="谈判文件" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="fileOptions"
            :el-attrs="{
              size: 'medium',
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:fileFee="{ value }">
              <span>{{ value ? strToThousands(value) : '0' }} 元</span>
              <money-in-cn class="m-l-5" :money="value" />
            </template>
            <template v-slot:signUpFee="{ value }">
              <div>
                <span class="m-r-10">
                  {{ value ? `${strToThousands(value)} 元` : '-' }}
                </span>
                <el-button
                  class="p-0"
                  type="text"
                  @click="openPlatformFeeDetail"
                >
                  查看计费规则
                </el-button>
              </div>
              <money-in-cn v-if="value" class="m-l-5" :money="value" />
            </template>
            <template v-slot:guaranteeFee="{ value }">
              <span>{{ value ? strToThousands(value) : '0' }} 元</span>
              <money-in-cn class="m-l-5" :money="value" />
            </template>
            <template v-slot:fileAttachmentGroupId>
              <upload-authorization-file
                v-if="orderInfo.negotiateFileIds"
                v-model="orderInfo.negotiateFileIds"
                upload-mode="fileId"
                :preview-api="previewPurchaseFileApi"
                :download-api="downloadPurchaseFileApi"
                :translate-data="{
                  downloadTranslate: 'fileUrl'
                }"
                :props-data="{
                  disabled: true
                }"
                :request-params="{
                  isRelease: true,
                  orderId: orderId
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-----谈判文件澄清----->
    <div v-if="attachmentList.length" class="card">
      <clarification-file
        :order-id="orderId"
        :attachment-list="attachmentList"
        :preview-api="previewClarificationFileApi"
        :download-api="downloadClarificationFileApi"
      />
    </div>

    <!-----所有公告----->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="所有公告" />
        </div>
        <div class="section-content">
          <bulletin-item
            v-if="purchaseNotice.title"
            :bulletin-label="!isInvite ? '谈判公告' : '邀请函'"
            :title="purchaseNotice.title"
            :content="purchaseNotice.content"
            :release-time="purchaseNotice.releaseTime"
            :button-text="!isInvite ? '查看公告' : '查看邀请函'"
            :is-time-norm-day="true"
          />
          <template v-if="changeNoticeList.length">
            <bulletin-item
              v-for="item in changeNoticeList"
              :key="(item || {}).noticeId"
              :bulletin-label="
                announcementTypeDict.translate((item || {}).noticeType).label
              "
              :title="(item || {}).title"
              :content="(item || {}).content"
              :release-time="(item || {}).releaseTime"
              :is-time-norm-day="true"
            />
          </template>
          <bulletin-item
            v-if="closeNotice.title"
            :bulletin-label="
              announcementTypeDict.translate(closeNotice.noticeType).label
            "
            :title="closeNotice.title"
            :content="closeNotice.content"
            :release-time="closeNotice.releaseTime"
            :is-time-norm-day="true"
          />
        </div>
      </div>
    </div>

    <!-- 平台使用费计费规则 --------->
    <charge-config-dialog
      ref="chargeConfigDialog"
      :config-obj="platformFeeConfig"
    />
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import BulletinItem from '@/components/common/Bulletins/BulletinItem'
import ClarificationFile from '@/components/common/ClarificationFile'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
import MoneyInCn from '@/components/common/MoneyInCn'
import OtherMaterialRequirements from '@/components/common/OtherMaterialRequirements/OtherMaterialRequirements'
import EntrustInfoDialog from '@/components/entrust/EntrustInfoDialog'
import ChargeConfigDialog from '@/components/common/ChargeConfigDialog'
import Upload from '@/components/common/Upload/index.vue'

import {
  getNegotiationV2DetailApi,
  getNegotiationV2PublishNoticeApi,
  previewPurchaseFileApi,
  downloadPurchaseFileApi,
  previewClarificationFileApi,
  downloadClarificationFileApi
} from '@/api/procure/negotiation-v2'
import { getPurchaseReviewDetailApi } from '@/api/procure/purchase-review'

import { costSubjectDict } from '@/dictionary/company'
import {
  negotiationV2TypeDict,
  negotiateMethodDict
} from '@/dictionary/project/negotiation-v2'
import {
  projectOpenScopeDict,
  projectTypeDict,
  whetherDict,
  announcementTypeDict,
  releaseMediaDict,
  isSignupShowListingDict,
  projectAssetDisposalMethodDict,
  purchaseTypeDict,
  offerTypeDict
} from '@/dictionary/project/common'
import { inquiryReviewModelDict } from '@/dictionary/project/inquiry'
import { workbenchServiceDict } from '@/dictionary/system'

import DateUtils from '@/utils/date'
import { strToThousands } from '@/utils/utils'

import { mapState } from 'vuex'
export default {
  components: {
    BaseSectionTitle,
    BulletinItem,
    ClarificationFile,
    UploadAuthorizationFile,
    MoneyInCn,
    OtherMaterialRequirements,
    EntrustInfoDialog,
    ChargeConfigDialog,
    Upload
  },

  props: {
    requestQuery: {
      type: Object,
      default: () => {}
    },

    isByOrderId: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      orderInfo: {},

      announcementTypeDict,

      platformFeeConfig: {},

      attachmentList: [],

      entrustProject: {},
      purchaseNotice: {}, // 采购公告信息
      changeNoticeList: [], // 变更公告列表
      closeNotice: {}, // 流标公告信息

      // 线上评审办法列表
      reviewList: [],
      onlineReviewId: 0
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),
    orderId() {
      return this.requestQuery.orderId || 0
    },

    // 是否是邀请供应商
    isInvite() {
      return this.orderInfo.competeType === negotiationV2TypeDict.INVITE.value
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    // 谈判采购信息
    infoOptions() {
      return [
        { label: '谈判采购名称', prop: 'orderName', elAttrs: { span: 3 } },
        { label: '谈判采购编号', prop: 'customOrderCode' },
        {
          label: '谈判采购预算',
          prop: 'budgetAmountWy',
          slotName: 'budgetAmountWy'
        },
        {
          label: '报名时间',
          prop: '',
          filter: value =>
            DateUtils.getNormMinuteRange(
              value.offerStartTime,
              value.offerEndTime
            )
        },
        {
          label: '提交响应文件截止时间',
          prop: 'negotiateTime',
          isNormMinute: true
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label
        },
        {
          label: '报价方式',
          prop: 'offerType',
          filter: value => offerTypeDict.translate(value).label || '-'
        },
        {
          label: '处置方式',
          prop: 'assetDisposalMethod',
          filter: value =>
            projectAssetDisposalMethodDict.translate(value)?.label ||
            projectAssetDisposalMethodDict.EXPENDITURE.label,
          hideFun: () =>
            this.orderInfo.projectType !== projectTypeDict.ASSET_DISPOSAL.value
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(
                    this.purchaseNotice?.noticeMedium
                  )?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          }
        },
        {
          label: '谈判方式',
          prop: 'negotiateMethod',
          filter: value => negotiateMethodDict.translate(value).label || '-'
        },
        {
          label: '谈判地点',
          prop: '',
          filter: value =>
            `${value?.province} - ${value?.city} - ${value?.area}`
        },
        { label: '详细地址', prop: 'address' }
      ]
    },
    // 竞争方式
    typeOptions() {
      return [
        {
          label: '竞争方式',
          prop: 'competeType',
          filter: value => {
            return negotiationV2TypeDict.translate(value).label || '-'
          }
        },
        {
          label: '报名时段查看供应商参与名单',
          prop: 'isSignupShowListing',
          dictArray: isSignupShowListingDict.array,
          hideFun: () => this.isInvite
        },
        {
          label: '报名审核',
          prop: 'bidApproval',
          dictArray: whetherDict.array,
          hideFun: () => this.isInvite
        },
        {
          label: '公开范围',
          prop: 'openScope',
          dictArray: projectOpenScopeDict.array,
          hideFun: () => this.isInvite
        },
        {
          label: '已选公开范围',
          prop: 'srmCategoryList',
          slotName: 'srmCategoryList',
          // filter: value =>
          //   (value || []).map(el => el.categoryName).join('，') || '-',
          hideFun: value =>
            !(
              !this.isInvite &&
              this.orderInfo.openScope === projectOpenScopeDict.COMPANY.value
            ),
          elAttrs: { span: 3 }
        },
        {
          label: '证件要求',
          prop: 'certRequireList',
          filter: value =>
            (value || []).map(el => el.certName).join('、 ') || '-',
          hideFun: () => this.isInvite || !this.needAudit,
          elAttrs: { span: 3 }
        },
        {
          label: '其他材料要求',
          prop: 'otherRequireList',
          slotName: 'otherRequireList',
          hideFun: () => this.isInvite || !this.needAudit,
          elAttrs: { span: 3 }
        },
        {
          label: '备注',
          prop: 'bidRequireRemark',
          hideFun: () => this.isInvite || !this.needAudit,
          elAttrs: { span: 3 }
        },
        {
          label: '邀请供应商',
          prop: 'inviteList',
          filter: value => {
            return (value || []).filter(el => !el.inviteType).map(el => el.supplierName).join('，')
          },
          hideFun: () => !this.isInvite,
          elAttrs: { span: 3 }
        },
        {
          label: '评审办法',
          prop: 'reviewModel',
          filter: value => inquiryReviewModelDict.translate(value).label || '-'
        },
        {
          label: '是否需线上评审',
          prop: 'isReview',
          filter: value => (value ? '是' : '否')
        },
        {
          label: '线上评审文件',
          prop: '',
          slotName: 'reviewWayList',
          hideFun: () => !this.orderInfo.isReview
        },
        {
          label: '追加供应商',
          prop: '',
          filter: value => {
            return (value.inviteList || []).filter(el => !!el.inviteType).map(el => el.supplierName).join('，')
          },
          hideFun: () => !this.isInvite,
          elAttrs: { span: 3 }
        },
        {
          label: '内部文件',
          prop: 'internalAttachments',
          slotName: 'internalAttachments',
          elAttrs: { span: 3 }
        }
      ]
    },

    // 谈判文件
    fileOptions() {
      return [
        {
          label: '标书费',
          prop: 'fileFee',
          slotName: 'fileFee'
        },
        {
          label: '平台使用费',
          prop: 'signUpFee',
          slotName: 'signUpFee',
          hideFun: () =>
            this.orderInfo.signUpFee === null || this.orderInfo.signUpFee === ''
        },
        {
          label: '保证金',
          prop: 'guaranteeFee',
          slotName: 'guaranteeFee',
          elAttrs: { span: 2 }
        },
        {
          label: '谈判文件',
          prop: '',
          slotName: 'fileAttachmentGroupId',
          elAttrs: { span: 3 }
        }
      ]
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val?.orderId) {
          this.orderInfo = this.requestQuery.orderInfo
          this.getOrderInfo()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getDetail()
        }
        this.getAllNotice()
      },
      immediate: true
    }
  },

  methods: {
    previewPurchaseFileApi,
    downloadPurchaseFileApi,
    previewClarificationFileApi,
    downloadClarificationFileApi,

    strToThousands,

    /**
     * 获取谈判详情
     */
    async getDetail() {
      if (!this.orderId) return
      try {
        const { data } = await getNegotiationV2DetailApi(this.orderId)
        this.orderInfo = {
          ...data.orderInfo,
          entrustProject: data.entrustProject || {},
          inviteList: data.inviteList || [],
          chargeList: data.chargeList || [],
          certRequireList: data.certRequireList || [],
          candidateId: data.candidateId,
          orderStatus: data.orderStatus,
          releaseTime: data.releaseTime,
          reviewId: data.reviewId,
          reviewStatus: data.reviewStatus,
          roundList: data.roundList || [],
          srmCategoryList: data.srmCategoryList || [],
          supplementList: data.supplementList || [],
          winnerId: data.winnerId,
          ownerCompanyName: data.ownerCompanyName,
          signupCnt: data.signupCnt,
          fileFeePayCnt: data.fileFeePayCnt,
          depositPayCnt: data.depositPayCnt
        }
        this.orderStatus = this.orderInfo.orderStatus
        this.oldStatus = this.orderInfo?.orderClose?.oldOrderStatus
        this.getOrderInfo()
        this.getPurchaseReviewOrder(this.orderInfo?.onlineReviewId)
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * @description: 获取所有公告列表
     * @param {*}
     * @return {*}
     */
    async getAllNotice() {
      try {
        const _data = await getNegotiationV2PublishNoticeApi(this.orderId)
        const data = _data.data || []

        this.purchaseNotice =
          data.find(
            el => el.noticeType === announcementTypeDict.PURCHASE.value
          ) || {}

        this.changeNoticeList = data.filter(
          el => el.noticeType === announcementTypeDict.CHANGE.value
        )

        this.closeNotice =
          data.find(el => el.noticeType === announcementTypeDict.FLOW.value) ||
          {}
      } catch (error) {
        this.$message.error(error.message || '获取公告信息失败')
      }
    },

    /**
     * 处理订单数据
     */
    getOrderInfo() {
      this.attachmentList = (this.orderInfo.supplementList || []).map(el => {
        el.supplementTime = el.releaseTime
        return el
      })
      this.platformFeeConfig =
        (this.orderInfo.chargeList || []).find(
          el => el.costSubject == costSubjectDict.REGISTER_FEE.value
        ) || {}
      this.entrustProject = this.orderInfo.entrustProject || {}
    },

    /**
     * 打开计费规则
     */
    openPlatformFeeDetail() {
      this.$refs.chargeConfigDialog.open()
    },

    // 查看线上评审文件
    jumpReviewInfo() {
      const routeParams = this.$route.params
      this.$router.push({
        name: this.entrustRouter + 'NegotiationOnlineReviewFile',
        params: routeParams,
        query: {
          reviewId: this.orderInfo.onlineReviewId,
          purchaseType: purchaseTypeDict.NEGOTIATION.value
        }
      })
    },

    /**
     * 查询线上评审单
     */
    getPurchaseReviewOrder(reviewId) {
      if (!reviewId) return
      getPurchaseReviewDetailApi(reviewId).then(res => {
        const _data = res.data || {}
        this.reviewList = _data.wayInfoList || []
        this.onlineReviewId = _data.reviewId
      })
    }
  }
}
</script>
